import { MetricParser } from "./MetricParser";
export class MetricDistance {
    constructor(mm) { this.mm = void 0; this.mm = Math.round(mm); }
    toString() { return this.mm.toString() + " mm"; }
    static parse(value) { const parsed = MetricParser.parse(value); return new MetricDistance(parsed.mm); }
    add(other) { return MetricDistance.fromUniversal(other.universalValue() + this.universalValue()); }
    universalValue() { return this.mm * MetricDistance.unitsPerMM; }
    static fromUniversal(n) { return new MetricDistance(n / MetricDistance.unitsPerMM); }
    static showMM(uu) { const len = MetricDistance.fromUniversal(uu); return len.toString(); }
} // // see dim/main.go
MetricDistance.unitsPerMM = 640;
